import SubmitButton from '../forms/SubmitButton'
import TextInput from '../forms/TextInput'
import {Dispatch, ReactElement, SetStateAction, useRef} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import {PhoneNumberUtil, PhoneNumberFormat} from 'google-libphonenumber'
import {event} from 'nextjs-google-analytics'
import {Fragment, useState} from 'react'
import alerts from '@/config/alerts.json'
import React from 'react'
import {
  Formik,
  Form,
  Field,
  FormikHelpers,
  useFormikContext,
  getIn,
} from 'formik'
import {useRouter} from 'next/router'
import toast from 'react-hot-toast'
import CustomToast from '../CustomToast'
import {RegisterSchema, RegisterValues} from '../../forms/Register'
import {useMutation} from 'react-query'
import PhoneInput from '../forms/PhoneInput'
import {Registeration, ResendVerification} from '@/services/api/auth'
import Verifications from './Verifications'
import {AnimatePresence, motion} from 'framer-motion'
import BackButton from '../BackButton'
import * as fbq from '@/services/fbpixel'
type Props = {
  isOpen: boolean
  setIsOpen: (arg0: boolean) => void
  setIsLoginOpen: (arg0: boolean) => void
  lastOpened: 'login' | 'register'
  setLastOpened: Dispatch<SetStateAction<'login' | 'register'>>
  setIsRegisterOpen: (arg0: boolean) => void
  setLoginMethod: Dispatch<SetStateAction<'email' | 'phone' | undefined>>
  loginMethod: 'email' | 'phone' | undefined
}

type VerificationData = {
  phone: {country_code: string; number: string}
}
export default function RegisterModal({
  isOpen,
  setIsOpen,
  setIsLoginOpen,
  setIsRegisterOpen,
  setLastOpened,
}: Props): ReactElement {
  const mutation = useMutation(Registeration)
  const [shouldVerify, setShouldVerify] = React.useState(false)

  const [verificationData, setVerificationData] =
    React.useState<VerificationData>()

  const ResendMutation = useMutation(ResendVerification)
  const handleVerification = (
    phone: string,
    country_code: string,
    actions: FormikHelpers<RegisterValues>,
  ) => {
    ResendMutation.mutate(
      {number: phone, country_code},
      {
        onSuccess() {
          toast.custom((t) => <CustomToast t={t} message={alerts.validation_code} type="success" />, {
            duration: 4000,
          });
          actions.resetForm()
          setShouldVerify(true)
        },
        onError(error: any) {
          toast.custom((t) => <CustomToast t={t} message={error.response.data.message} type="error" />, {
            duration: 4000,
            id: 'Validation Error'
          });
        },
      },
    )
  }

  const [iso2, setIso2] = React.useState('IL')
  const handleSubmit = async (
    values: RegisterValues,
    actions: FormikHelpers<RegisterValues>,
  ) => {
    const phoneUtil = PhoneNumberUtil.getInstance()
    const parsedNumber = phoneUtil.parseAndKeepRawInput(values.phone, iso2)
    const isValid = phoneUtil.isValidNumber(parsedNumber)

    if (!isValid) {
      actions.setFieldError('phone', 'Phone Number is Invalid')
      return
    }
    mutation.mutate(
      {referral: localStorage.getItem('referral'), ...values},
      {
        onSuccess(data) {
          //actions.resetForm()
          setVerificationData({
            phone: {country_code: data.country_code, number: data.phone},
          })
          handleVerification(data.phone, data.country_code, actions)

          localStorage.removeItem('referral')
          event('signup')
          fbq.event('CompleteRegistration', {content_name: values.first_name})
        },
        onError(error: any) {
          if (error.response.data.message == 'Phone Number already Exists') {
            actions.setFieldError('phone', error.response.data.message)
          } else if (
            error.response.data.message == 'The email has already been taken.'
          ) {
            actions.setFieldError('email', error.response.data.message)
          } else {
            actions.setFieldError('first_name', error.response.data.message)
          }
          toast.custom((t) => <CustomToast t={t} message={error.response.data.message} type="error" />, {
            duration: 4000,
            id: 'Registration Error'
          });
        },
      },
    )
  }

  const ref = useRef(null)

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95">
              <Dialog.Panel className="w-full max-w-md xl:max-w-2xl transform overflow-hidden rounded-2xl bg-white text-left align-middle shadow-xl transition-all">
                <Dialog.Title className="text-lg font-medium p-3 lg:px-6 lg:pt-8 xl:px-8 xl:pt-12 2xl:px-11 lg:pb-6 xl:pb-8 2xl:pb-8">
                  <div className="flex  items-center justify-between">
                    <div className="heading-text">
                      <h3 className="text-primary-500 text-right text-2xl font-bold lg:text-3xl">
                        {verificationData ? 'تسجيل حساب' : 'تسجيل حساب جديد'}
                      </h3>
                      <p className="font-light mt-2 text-right text-sm lg:text-base mb-0">
                        {verificationData
                          ? 'يرجى ادخال البيانات التالية'
                          : 'يرجى ادخال البيانات التالية'}
                      </p>
                    </div>
                    <div>
                      {verificationData ? (
                        <BackButton
                          onClick={() => {
                            setShouldVerify(false)
                            setVerificationData(undefined)
                          }}
                        />
                      ) : (
                        <a
                          href="#"
                          onClick={e => {
                            e.preventDefault()
                            setIsRegisterOpen(false)
                          }}
                          className="close-icon inline-block border bg-gray-200 rounded-md p-2 self-end cursor-pointer">
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 21 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M11.9109 10.2326L20.201 1.94261C20.3648 1.75131 20.4504 1.50523 20.4407 1.25355C20.4309 1.00188 20.3266 0.763139 20.1485 0.585044C19.9704 0.40695 19.7317 0.302617 19.48 0.292896C19.2283 0.283175 18.9823 0.368781 18.791 0.532608L10.5009 8.82261L2.21095 0.522607C2.02265 0.334304 1.76725 0.228516 1.50095 0.228516C1.23465 0.228516 0.979253 0.334304 0.79095 0.522607C0.602646 0.710911 0.496858 0.966306 0.496858 1.23261C0.496858 1.49891 0.602646 1.7543 0.79095 1.94261L9.09095 10.2326L0.79095 18.5226C0.686268 18.6123 0.601248 18.7226 0.541224 18.8466C0.481201 18.9707 0.447471 19.1058 0.442151 19.2436C0.436832 19.3813 0.460037 19.5186 0.510312 19.6469C0.560587 19.7753 0.636845 19.8918 0.7343 19.9893C0.831754 20.0867 0.948302 20.163 1.07663 20.2132C1.20495 20.2635 1.34228 20.2867 1.48 20.2814C1.61772 20.2761 1.75285 20.2424 1.87692 20.1823C2.00098 20.1223 2.1113 20.0373 2.20095 19.9326L10.5009 11.6426L18.791 19.9326C18.9823 20.0964 19.2283 20.182 19.48 20.1723C19.7317 20.1626 19.9704 20.0583 20.1485 19.8802C20.3266 19.7021 20.4309 19.4633 20.4407 19.2117C20.4504 18.96 20.3648 18.7139 20.201 18.5226L11.9109 10.2326Z"
                              fill="gray"
                            />
                          </svg>
                        </a>
                      )}
                    </div>
                  </div>
                </Dialog.Title>
                <div className="modal-content p-3 lg:p-6 xl:p-8 2xl:p-11 pt-0 lg:pt-0 xl:pt-0 2xl:pt-0">
                  <AnimatePresence>
                    <motion.div
                      initial={{opacity: 0, translateX: '10%'}}
                      transition={{type: 'spring', duration: 0.5}}
                      animate={{opacity: 1, translateX: '0'}}
                      exit={{opacity: 0, translateX: '10%'}}>
                      {verificationData && shouldVerify ? (
                        <Verifications
                          phone={verificationData.phone}
                          fromRegister={true}
                          setLastOpened={setLastOpened}
                          setIsLoginOpen={setIsLoginOpen}
                          setShouldVerify={setShouldVerify}
                          setVerificationData={setVerificationData}
                          setIsRegisterOpen={setIsRegisterOpen}
                        />
                      ) : (
                        <>
                          <AnimatePresence>
                            <motion.div
                              initial={{opacity: 0, translateX: '10%'}}
                              transition={{type: 'spring', duration: 0.5}}
                              animate={{opacity: 1, translateX: '0'}}
                              exit={{opacity: 0, translateX: '10%'}}>
                              <>
                                <Formik
                                  initialValues={{
                                    first_name: '',
                                    last_name: '',
                                    email: '',
                                    phone: '',
                                    password: '',
                                    country_code: '+971',
                                  }}
                                  innerRef={ref}
                                  validationSchema={RegisterSchema}
                                  validateOnChange={false}
                                  validateOnBlur={false}
                                  onSubmit={handleSubmit}>
                                  {({
                                    errors,
                                    touched,
                                    values,
                                    setFieldValue,
                                    setFieldError,
                                  }) => (
                                    <RegisterForm
                                      errors={errors}
                                      touched={touched}
                                      values={values}
                                      setFieldValue={setFieldValue}
                                      setFieldError={setFieldError}
                                      ResendMutation={ResendMutation}
                                      mutation={mutation}
                                      setIso2={setIso2}
                                    />
                                  )}
                                </Formik>
                                <p className="text-center mt-6 text-xs">
                                  هل لديك حساب بالفعل؟
                                  <a
                                    href="#"
                                    onClick={() => {
                                      setIsOpen(false)
                                      setTimeout(() => {
                                        setLastOpened('login')
                                        setIsLoginOpen(true)
                                      }, 500)
                                    }}
                                    data-test="register-page"
                                    className="text-primary cursor-pointer underline font-bold mr-1 mt-4">
                                    تسجيل الدخول إلى حسابك
                                  </a>
                                </p>
                              </>
                            </motion.div>
                          </AnimatePresence>
                        </>
                      )}
                    </motion.div>
                  </AnimatePresence>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
function RegisterForm({
  errors,
  touched,
  setFieldError,
  setFieldValue,
  setIso2,
  values,
  mutation,
  ResendMutation,
}: any) {
  //const { values } = useFormikContext()

  //const passwordValue = getIn(values, 'password')
  //React.useEffect(() => {
  //if (passwordValue.length < 8 && passwordValue.length != 1) {
  //setFieldError('password', 'استخدم 8 أحرف أو أكثر')
  //} else if (passwordValue.length == 0) {
  //setFieldError('password', '')
  //} else {
  //setFieldError('password', '')
  //}
  //}, [passwordValue])
  return (
    <Form>
      <div className="col lg:flex flex-row">
        <div className="form-group flex flex-col mt-3 w-full">
          <TextInput
            label={'الاسم الاول*'}
            type="text"
            name="first_name"
            placeholder={'اكتب الاسم الأول الخاص بك'}
            isError={errors.first_name && touched.first_name}
            error={errors.first_name}
          />
        </div>
        <div className="form-group flex flex-col mt-3 w-full lg:mr-4">
          <TextInput
            label={'اسم العائلة*'}
            type="text"
            name="last_name"
            placeholder={'اكتب اسمك الأخير'}
            isError={errors.last_name && touched.last_name}
            error={errors.last_name}
          />
        </div>
      </div>

      <div className="form-group flex flex-col mt-3">
        <PhoneInput
          values={values}
          setFieldError={setFieldError}
          setFieldValue={setFieldValue}
          setIso2={setIso2}
          isError={errors.phone && touched.phone}
          error={errors.phone}
          label="اكتب رقم هاتفك*"
        />
      </div>
      <div className="form-group flex flex-col mt-3">
        <TextInput
          label={'البريد الالكتروني*'}
          type="email"
          name="email"
          placeholder={'قم بكتابة البريد الإلكتروني هنا'}
          isError={errors.email && touched.email}
          error={errors.email}
        />
      </div>
      <div className="form-group flex flex-col mt-3">
        <TextInput
          label={'اختر كلمة السر*'}
          type="password"
          name="password"
          placeholder={'اختر كلمة السر هنا'}
          isError={errors.password && touched.password}
          error={errors.password}
        />
      </div>

      <SubmitButton
        text={'إنشاء حساب'}
        isLoading={mutation.isLoading || ResendMutation.isLoading}
      />
    </Form>
  )
}
